export default {
  cancel: 'Cancel',
  ok: 'Ok',
  yes: 'Yes',
  no: 'No',
  save: 'Save',
  download: 'Download',
  downloading: 'Downloading...',
  assignmentPeriod: 'Assignment Period',
  'manageAddDropPeriod': 'Manage Add/Drop Period',
  manageAssignmentPeriod: 'Manage Assignment Period',
  publishAssignment: 'Publish Assignment',
  manageClasses: 'Manage Classes',
  manageStudents: 'Manage Students',
  manageGroups: 'Manage Groups',
  assignClasses: 'Assign Classes',
  class: 'Class',
  classAssignmentInProgress: 'Class Assignment In Progress',
  classNamePh: 'Class Name',
  classNameDesc: 'Class Name',
  classDescriptionPh: 'Class Assignment Description',
  classDescriptionDesc: 'Class assignment period description can be up to 150 characters in length',
  emailAddress: 'Email Address',
  classEmailDesc: 'Students will see this email address as their point of contact',
  Optional: '(Optional)',
  additionalFindClassesDesc: 'Instructions for the Find Classes page of the student interface',
  additionalRankClassesDesc: 'Instructions for the Rank Classes page of the student interface',
  additionalViewSchedulesDesc: 'Instructions for the View Schedules page of the student interface',
  rankingSessionNotOpenTextDesc: 'Students will see this text when the ranking session is not open',
  additionalFindClassesAddDropDesc: 'Instructions for the Find Classes page of the student interface',
  additionalManageWaitlistDesc: 'Instructions for the Manage Waitlists page of the student interface',
  additionalManageScheduleDesc: 'Instructions for the Manage Schedule page of the student interface',
  addDropNotOpenTextDesc: 'Students will see this text above their assigned schedules when the add/drop session is not open',
  classUploadClasses: 'Import Student and Class Information',
  classesUploadDescription:
    'Use the example Microsoft Excel file as a guide to create a new import file with the data for your assignment period.',
  classExampleFile: 'Example File',
  classImport: 'Import',
  openRankingSession: 'Open Ranking Session',
  openRankingSessionStatus: 'Starting Ranking Session...',
  assignClassesStatus: 'Assignment is starting...',
  cancelAssignmentStatus: 'Assignment is stopping...',
  reopenRankingSession: 'Re-open Ranking Session',
  closeRankingSession: 'Close Ranking Session',
  restrictions: 'Restrictions',
  assignRestrictions: 'Assignment Period Restrictions',
  groupRestrictions: 'Group Member Restrictions',
  addRestriction: 'Add Conflict',
  addRequirement: 'Add Requirement',
  createConflict: 'Create Conflict',
  editConflict: 'Edit Conflict',
  createRequirement: 'Create Requirement',
  editRequirement: 'Edit Requirement',
  createConflictModalBody: 'Enter the following information to create a Conflict:',
  createRequirementModalBody: 'Enter the following information to create a Requirement:',
  creationTitle: 'Set up Classes, Students, and Groups',
  creationMessage:
    'After finishing setting up the assignment period, open the ranking session to allow students to select their classes. Students will be emailed to alert them that the ranking session is open.',
  elicitationTitle: 'Ranking Session in Progress',
  modificationTitle: 'Ranking Session Closed',
  modificationMessage:
    'Now that students have ranked their classes, you can start the computational process that will fairly assign students to their classes.',
  calculationTitle: 'Class Assignment in Progress',
  calculationMessage:
    'Any modifications you make now to the assignment period, like changing class capacities, will not be reflected in the in-progress assignment. If you need to make changes, cancel the assignment and restart it.',
  cancelAssignment: 'Cancel Assignment',
  completedAssignmentHeader: 'Completed Assignments are Available',
  completedAssignmentMessage:
    'Select a completed assignment and view its summary on our dashboard, or go in depth by downloading the assignment. Please note that assignments may not reflect changes you have made changes since they were computed.',
  downloadAssignmentExcel: 'Download Excel',
  downloadAssignmentJson: 'Download JSON',
  progressSidebarTitle: 'Ranking Session Status',
  studentSelectionStatusTitle: 'Class Selection Status',
  deleteConfirmation: 'Confirmation',
  toastrDeleteSuccessful: 'Item deleted successfully',
  assignmentStatus: 'Assignment Status',
  addConfFormName: 'Name',
  addConfFormNameDesc: 'Enter a name for this conflict that is less than 50 characters.',
  addReqFormNameDesc: 'Enter a name for this requirement that is less than 50 characters.',
  addConfFormAddClasses: 'Select the classes for the conflict',
  addReqFormAddClasses: 'Select the classes for the requirement',
  deleteConfConfirmCustomMsg: 'Are you sure you want to delete this conflict?',
  deleteReqConfirmCustomMsg: 'Are you sure you want to delete this requirement?',
  deleteAdminCustomMsg: 'Are you sure you want to delete this administrator?',
  q1: 'How do I set up my files for import?',
  a1: 'Please contact your customer support team to get assistance setting up your files for import.',
  q2: 'What is an assignment period?',
  a2:
    'This is the period for which you’re setting up Cognomos as a selection tool. At most schools this is a semester or a trimester.',
  q3: 'What are restrictions?',
  a3:
    'Locks are classes that a group of students are currently not allowed to take. Requirements are groups of classes that a set of students may be required to take, whether it’s one from a list or just taking a single class. Conflicts are classes that for some reason cannot be taken at the same time. It could be because they meet at the same time or because they have overlapping content. To request a release from any restriction, students contact your administrator via email. The release can then be granted from the individual student’s page.',
  q4: 'What are releases?',
  a4:
    'Releases are overrides an administrator can place in the system to allow a student to take classes that otherwise would be locked, required, or conflicted. Releases can all be granted on the individual student’s page.',
  q5: 'What’s the difference between a course name and identifier?',
  a5:
    'The course name is what will be displayed to the students. Sometimes classes have different ID numbers in an internal system, whether it’s to include individual sections or some other reason.',
  q6: 'What’s target and maximum capacity?',
  a6:
    'Administrators often try to overbook certain classes with the expectation that some students will drop before class registration closes. The target capacity is the class capacity that will be displayed to the students, while the max capacity is the maximum number of students Cognomos will assign to the class.',
  q7: 'What are budgets?',
  a7:
    ' Budgets are how you allow certain groups of students to get their preferred classes above other groups. For instance, many schools choose to give students in their final year preference over students who will be returning. By assigning graduating students a higher budget, they will be prioritized when classes are assigned. To learn more about how to set up budgets for your particular use case, contact your customer success team.',
  courseForm_ClassName: 'Class Slug',
  courseForm_ClassNameDesc: 'Add a class slug',
  courseForm_ClassIdentifier: 'Class Identifier',
  courseForm_ClassIdentifierDesc: 'Add a class identifier',
  courseForm_ClassLongname: 'Class Description',
  courseForm_ClassLongnameDesc: 'Class description can be up to 150 characters in length',
  courseForm_ClassDescription: '(Optional) Extended Class Description',
  courseForm_ClassDescriptionDesc: 'Students will see this text when they are ranking this course',
  courseForm_LinkToClass: 'Link To Class',
  courseForm_LinkToClassDesc: 'Enter the URL to the full class description',
  courseForm_Credits: 'Credits',
  courseForm_CreditsDesc: 'Enter the number of credits earned for the class',
  courseForm_InstructorName: 'Instructor Name',
  courseForm_InstructorNameDesc: 'Enter the name of the instructor for the class',
  courseForm_DisplayedCapacity: 'Displayed Capacity',
  courseForm_DisplayedCapacityDesc: 'Capacity of the class',
  courseForm_MaxCapacity: 'MaxCapacity',
  courseForm_MaxCapacityDesc: 'Actual capacity of class (See FAQs)',
  addMeeting: 'Add Meeting',
  createMeeting: 'Create Meeting',
  editMeeting: 'Edit Meeting',
  createMeetingModalBody: 'Enter the following information to create a Meeting:',
  meetingFormLocationDesc: 'Enter location for this class that is less than 50 characters.',
  deleteMeetingCustomMsg: 'Are you sure you want to delete this meeting?',
  deleteDiscountCustomMsg: 'Are you sure you want to delete this discount?',
  deleteExclusiveCustomMsg: 'Are you sure you want to delete this Exclusive?',
  deleteCourseCustomMsg:
    'Deleting this class will permanently delete all of its student rankings. To save these rankings without assigning students to this class, set the capacity to zero before running an assignment.',

  addCrosslist: 'Add Crosslist',
  addDiscount: 'Add Discount',
  createCrosslist: 'Create Crosslist',
  createDiscount: 'Create Discount',
  editCrosslist: 'Edit Crosslist',
  editDiscountlist: 'Edit Discount',
  deleteCrosslist: 'Delete Crosslist',
  deleteDiscount: 'Delete Discount',
  createCrosslistModalBody: 'Enter the following information to create a Crosslist:',
  createDiscountlistModalBody: 'Enter the following information to create a Discount:',
  crosslistFormSlug: 'Slug',
  crosslistFormSlugDesc: 'Enter crosslist slug',
  crosslistFormLongname: 'Description',
  crosslistFormLongnameDesc: 'Crosslist description can be up to 150 characters in length',
  student: 'Student',
  studentEmailDesc: 'Enter student email',
  studentIdentifier: 'Student Identifier',
  targetCourseUnits: 'Minimum Credits',
  maxCourseUnits: 'Target Credits',
  studentIdentifierDesc: 'Enter student identifier',
  baseBudget: 'Base Budget',
  adjustedBudget: 'Adjusted Budget',
  deleteStudentCustomMsg: 'Are you sure you want to delete this student?',
  addStudentToGroups: 'Add Student To Groups',
  addStudentToGroup: 'Add Students To Group',
  addGroupModalBody: 'Select Groups to put this student into:',
  addStudentModalBody: 'Select Students to put into this group:',
  group: 'Group',
  groupName: 'Group Name',
  groupNameDesc: 'Enter group name',
  groupDescription: 'Group Description (optional)',
  groupDescriptionDesc: 'Group description can be up to 150 characters in length',
  groupBudgetAdjustmentDesc: 'Each student in the group gets the budget increase you select',
  deleteGroupCustomMsg: 'Are you sure you want to delete this group?',
  addLock: 'Add Lock',
  addLockModalBody: 'Select Classes to lock:',
  createReleaseModalTitle: 'Create Release',
  createReleaseModalBody: 'Search Classes to filter Restrictions:',
  run_lock: 'Assignment Period Lock',
  run_conflict: 'Assignment Period Conflict',
  run_requirement: 'Assignment Period Requirement',
  group_lock: 'Group Lock',
  group_conflict: 'Group Conflict',
  group_requirement: 'Group Requirement',
  sq1: 'Does anyone else’s class selections influence how I should rank my classes?',
  sa1:
    'No. The system works hard to give everyone their top-choice classes. Even if a class is very popular you should rank it according to your own preferences. Trying to “game” the system will only result in your not getting the classes you want.',
  sq2: 'What are restrictions?',
  sa2:
    'Locks are classes that you are currently not allowed to take. Requirements are groups of classes that you’re required to take, whether it’s one from a list or just taking a single class. Conflicts are classes that for some reason cannot be taken at the same time. It could be because they meet at the same time or because they have overlapping content. To request a release from any restriction, please contact your administrator.',
  sq3: 'What are releases?',
  sa3:
    'Releases are overrides your administrator can place in the system to allow you to take classes that otherwise would be locked, required, or conflicted.',
  sq4: 'What should I do if I don’t think any of my schedules are great?',
  sa4:
    'That means your class rankings aren’t quite right. Go back and re-order your classes and see if the schedules are better matches. Keep tweaking how you’ve ranked your classes until you’re excited about one of your schedules. And of course make sure that you’re excited about the classes you chose!',
  sq5: 'Will I get exactly the number of target credits I select?',
  sa5:
    'Not necessarily. The system will try to get you exactly the number of credits you requested, but depending on how your school does courses and credits it may end up getting you close but not exactly there.',
  sq6: 'Can you explain linking classes more?',
  sa6:
    'Some students really want to take a class of a certain type, but don’t want to take too many of that type. Perhaps there are three finance classes that are all different but interesting, but you only want to take one finance class this period. Given that, you should use the linking option to only assign you one of the group, but not all of them.',
  getStartedForm_targetCredit_label: 'Minimum Credits',
  getStartedForm_targetCredit_desc: 'Minimum',
  getStartedForm_maxCredit_label: 'Target Credits',
  getStarterForm_maxCredit_desc: 'Target',
  linksModal_body:
    'Linking lets you take only one, two, or three of a set of classes. You can use links to, for instance, limit the number of elective classes that you get assigned.',
  linksForm_title: 'Create Rule',
  linksForm_title_modify: 'Modify Rule',
  linksForm_classes_label: 'Classes',
  linksForm_classes_desc: 'Select classes to link',
  linksForm_name_desc: 'Enter a name for this conflict that is less than 50 chracters',
  linksForm_nameshort_desc: 'Add a short name to describe this rule',
  linksForm_linkType_label: 'Assign me no more than...',
  linksForm2_linkType_label: 'Assign me no more than one of:',
  linksForm_linkType_desc: 'Select how many linked classes you want to be assigned',
  rankText1:
    'Rank the classes you chose according to how interested you are in taking them. The higher up you place a class, the harder the system will work to assign you that class. The first class on your list should be your favorite class, descending from there. The different sections (favorite; great; good; acceptable) are for big differentiation between classes, while the ranking within each section is for smaller adjustments and preferences between them. You do not have to place classes in every section.',
  rankText2:
    'If there are a set of classes that you are interested in but would only like to take one, two, or three of (like if you are interested in taking a finance class but only want to take one of them) click any ',
  rankText3: 'button to get to the linking tool. That allows you to set preferences on multiple classes together.',
  schedulesText1:
    'Based on your rankings, we’ve created a list of what we think are your most preferred schedules. The system cannot guarantee you will get one of these schedules. However, you will get a schedule very similar to the ones listed here.',
  schedulesText2:
    'Since the system attempts to assign you to these top schedules in order, if this list does not align with your preferences you should try ranking your classes differently or changing the number of course units you want this period. Remember that ranking more classes never hurts your chances of getting a seat in any class.',
  schedulesText3:
    'Once you’re happy with your potential schedules, congratulations, you’re all done! But you can come back any time until the ranking session is closed to make adjustments.',
  getStartedStep1: 'Step 1. ',
  getStartedStepText1:
    'Find classes you’re interested in. We suggest adding at least twice the number of classes you’re interested in taking to your list. So if you want to take 4 classes next semester, you should add at least 8 classes.',
  getStartedStep2: 'Step 2. ',
  getStartedStepText2:
    'Once you’ve added your classes to your list, sort them in order of how important the class is to you. Rank classes you are most interested in higher on your list, and your second-choice classes lower down. The system works hard to give you as many classes from the top of your list as you want to take.',
  getStartedStep3: 'Step 3. ',
  getStartedStepText3:
    'You can also link classes on the ranking page. This tool should be used if there are multiple classes you’re really excited about, but you would only like to take one or two of the group.',
  getStartedStep4: 'Step 4. ',
  getStartedStepText4:
    'Once you’ve ranked classes, you can view your potential schedules. The system will show schedules starting with ones it thinks you’ll like the most and  will try its best to get you the highest-ranking schedule possible.',
  getStartedStep5: 'Step 5. ',
  getStartedStepText5:
    'If your top schedules do not match your preferences, go back and re-rank your classes. Changing the order of classes will change the schedules you see. Keep re-ranking classes until your top few schedules match your preferences.',
  getStartedStep6: 'Step 6. ',
  getStartedStepText6:
    'Once you’re happy with your potential schedules, you’re  all finished. But you can come back any time until the ranking session has closed to make adjustments.',
  studentsMinChangeDesc: 'Allow students to change minimum course numbers',
  studentsMaxChangeDesc: 'Allow students to change target course numbers',
  sendStudentsEmailDesc: 'Send email confirmations to students about ranking changes',
  additionalStudentText: '(Optional) Additional Guidance',
  additionalStudentTextDesc:
    'Students will see this extra text on the Getting Started page of their ranking interface.',
  disabledClassChangeDesc:
    'Disabled inputs indicate that class choice numbers have been set for you. If you\'d like to change these values, email the administrator of this assignment period at',
  ssoNote:
    'Cognomos has integrated with your school\'s Single Sign On provider. Clicking the button below will redirect you to your school\'s authentication server to log in.'
};



// WEBPACK FOOTER //
// ./src/utils/lngEn.js